var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addModel"}},[_c('form-dialog',{attrs:{"model-param":_vm.modelParam,"model-data":_vm.modelData,"title":("新建模型 | " + (this.modelType))},on:{"refresh":_vm.handlerRefresh}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }